import styled from 'styled-components';
import { primitives } from '@veneer/primitives';
import { Button } from '@veneer/core';

const { color, typography } = primitives;

export const TermsServiceContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;
export const TermsContainer = styled.div`
  padding: 24px;
  border: 1px solid ${color.gray3};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${color.white};
`;

export const Heading = styled.h2`
  font-family: ${typography.family0};
  font-size: ${typography.size4};
  color: ${color.gray12};
  line-height: ${typography.lineHeight4};
  font-weight: ${typography.weight4};
`;

export const TermsText = styled.p`
  font-size: ${typography.size0};
  line-height: ${typography.lineHeight1};
`;

export const TermTitle = styled.span`
  color: ${color.gray12};
  font-weight: bold;
`;

export const TermDescription = styled.span`
  color: ${color.gray7};
`;

export const Separator = styled.div`
  border-bottom: 1px solid ${color.gray3};
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  > label > span:first-child {
    display: inline-block;
    margin-top: 8px;
  }
  > label > span:last-child {
    font-size: ${typography.size0};
  }
`;
export const ActionButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const ContinueButton = styled(Button)`
  &:disabled {
    background-color: ${color.gray3};
    color: ${color.gray5};
    cursor: not-allowed;
  }
`;
export const UnderstandBlock = styled.div`
  padding: 15px 24px;
  border: 1px solid ${color.gray3};
  border-radius: 8px;
  font-family: ${typography.family0};
  font-size: ${typography.size0};
  line-height: ${typography.lineHeight1};
  background-color: ${color.white};
`;
export const RedirectLink = styled.a`
  {
      cursor: pointer;
      text-decoration: underline;
      color: ${color.electricBlue7};
      &:hover,
      &:visited
      &:active {
        color: ${color.electricBlue7};
      }
`;
